import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { NewActionTaxonomyActionComponent } from '../new-action-taxonomy-action/new-action-taxonomy-action.component';
import { DynamicContentComponent } from 'app/shared/dynamic-content/dynamic-content.component';

@Component({
  selector: 'kla-new-action-taxonomy-strategy',
  templateUrl: './new-action-taxonomy-strategy.component.html',
  styleUrls: ['./new-action-taxonomy-strategy.component.scss'],
  standalone: true,
  imports: [ CommonModule, MatExpansionModule, NewActionTaxonomyActionComponent, DynamicContentComponent ]
})
export class NewActionTaxonomyStrategyComponent implements OnInit {


  @Input() strategy;
  @Input() color: any;
  @Input() includeTier: any;
  @Input()
  public config: any;
  panelOpenState: boolean;

  constructor() { }

  ngOnInit(): void {
  }

  handleOpened() {
    this.panelOpenState = true;
  }

  handleClosed() {
    this.panelOpenState = false;
  }

  addAlpha(color: string, opacity: number, device: string = 'xl'): string {
    if (device != 'xs' || this.isMobile()) {
      const _opacity = Math.round(Math.min(Math.max(opacity || 1, 0), 1) * 255);
      return color + _opacity.toString(16).toUpperCase();
    } else {
      return;
    }
  }

  isMobile() {
    return window.innerWidth < 767;
  }


}
